/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import { useNavigate } from "react-router-dom";
import { ClickAwayListener, Input } from "@mui/material";
import {

  Menu,
  MenuItem,
  Paper,
  Select,
  SelectChangeEvent,

} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  useLazyGetUserQuery,
  usePostLogoutMutation,
} from "../../../service/auth";
import { getFromStorage, setToStorage } from "../../../constants/storage";
import {
  getToken,
  resetAuth,
  role,
  setCredentials,
} from "../../../reducers/authSlice";
import { showError, showToast } from "../../../constants/toast";
import { STORAGE_KEYS } from "../../../constants/storageKeys";
import { useDispatch } from "react-redux";
import { useAppDispatch, useAppSelector } from "../../../hooks/store";
import { useDebounce } from "../../../constants/useDebounce";
import { useGetSearchQueryQuery } from "../../../service/parentDashboard";
import StarIcon from "@mui/icons-material/Star";
import useAuth from "../../../hooks/useAuth";
import LogoutModal from "../../../Modals/logout";
import { useLazyGetNotificationsQuery } from "../../../service/tutorApi";
import CURRENCY from "../../../constants/Currency";
import CurrencyModal from "../../../Modals/CurrencyModel";
import useExchangeCurrency from "../../../hooks/useCurrency";
import { setCurrencyMode, setCurrencySymbol, setCurrentCurrency } from "../../../reducers/currencySlice";

type props = {
  zoom: boolean;
};

const ParentHeader = ({ zoom }: props) => {
  const navigate = useNavigate();
  useExchangeCurrency();
  const [getProfile] = useLazyGetUserQuery();
  const [open, setOpen] = React.useState(false);
  const [showInput, setShowInput] = useState<boolean>(false);
  const [query, setQuery] = useState<string>("");
  const debounceValue = useDebounce(query, 750);
  const userDetails = useAuth();
  const token = getFromStorage(STORAGE_KEYS.token);
  const crData = localStorage.getItem("currency") ? JSON.parse(localStorage.getItem("currency") || "") : {
    currency: 'USD',
    code: 'en-US',
    symbol: '$',
    flag: 'https://flagcdn.com/w80/us.png',
  };
  const [openCurr, setOpenCurr] = useState<boolean>(false);
  const { data, isLoading, isSuccess, isError } = useGetSearchQueryQuery(
    {
      query: debounceValue,
    },
    { skip: !debounceValue }
  );
  const [getNotifications] = useLazyGetNotificationsQuery();
  const [notifications, setNotifcations] = useState<any>([]);
  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };
  const dispatch = useAppDispatch();
  const tokenFromRed = useAppSelector(getToken);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement> | any) => {
    setAnchorEl(event.currentTarget);
  };



  const [notificationAnchorEl, setNotificationAnchorEl] = useState<null | HTMLElement>(null);
  // Notification menu
  const handleNotificationClick = (event: React.MouseEvent<HTMLElement>) => {
    setNotificationAnchorEl(event.currentTarget);
  };
  const handleNotificationClose = () => {
    setNotificationAnchorEl(null);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [openLog, setOpenLog] = useState<boolean>(false);
  const handleCloseLog = () => {
    setOpenLog(false);
  };

  const setRole = () => {
    dispatch(role({ roleName: "parent" }));
  };

  const [notiType, setNotiType] = React.useState("0");
  const handleChange = (event: SelectChangeEvent) => {
    setNotiType(event.target.value as string);
  };
  const fetchUser = async () => {
    const token = getFromStorage(STORAGE_KEYS.token);
    try {
      const res = await getProfile({}).unwrap();
      if (res?.statusCode === 200) {
        dispatch(
          setCredentials({
            user: res?.data || null,
            token: token || null,
          })
        );
      }
    } catch (error: any) {
      showError(error?.data?.message);
    }
  };

  useEffect(() => {
    if (window) {
      window.scrollTo({ top: 0, behavior: "auto" });
    }
  }, []);

  useEffect(() => {
    setRole();
  }, []);

  useEffect(() => {
    if (tokenFromRed) {
      fetchUser();
    }
  }, [tokenFromRed]);
  const fetchNotification = async () => {
    try {
      const res = await getNotifications({}).unwrap();
      if (res?.statusCode === 200) {
        setNotifcations(res?.data);
      }
    } catch (error: any) {
      showError(error?.data?.message);
    }
  };



  const fetchProfile = () => {
    const token = getFromStorage(STORAGE_KEYS.token);
    const userData = getFromStorage(STORAGE_KEYS.user);
    if (token) {
      dispatch(
        setCredentials({
          user: userData || null,
          token: token || null,
        })
      );
      dispatch(role({ roleName: "parent" }));
    }
  };
  const handleClick3 = (e: React.MouseEvent<HTMLElement>) => {
    // Toggle open/close on figure click
    if (anchorEl) {
      handleClose();
    } else {
      setAnchorEl(e.currentTarget);
    }
  };
  const handleClose3 = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    fetchProfile();
  }, []);

  useEffect(() => {
    const token = getFromStorage(STORAGE_KEYS.token);
    if (token) {
      fetchNotification();
    }
  }, []);

  useEffect(() => {
    const storedCurrency: any = localStorage.getItem("currency");

    if (storedCurrency !== null || storedCurrency !== undefined) {
      try {
        const cr = JSON.parse(storedCurrency);

        if (cr) {
          dispatch(setCurrentCurrency(cr?.currency ?? ""));
          dispatch(setCurrencyMode(cr?.code ?? ""));
          dispatch(setCurrencySymbol(cr?.symbol ?? ""));
        }
      } catch (error) {
        console.error("Invalid currency data in localStorage:", error);
        localStorage.removeItem("currency"); // optional: clean invalid data
      }
    }
  }, []);



  return (
    <>
      <header
        className={zoom ? "site_header v2 zoom_header" : "site_header v2"}
      >
        <div className="main_header">
          <div className="conta_iner v2">
            <nav>


              <div className="header_lts">
                <a
                  onClick={() => (zoom ? window.open("/") : navigate("/"))}
                  className="site_logo"
                >
                  <figure>
                    <img src={`/static/images/logo.png`} alt="logo" />
                  </figure>
                </a>

                <div className="input_group">
                  <Input className="form_control" placeholder="Search" />
                  <span><img src={`/static/images/search-outline.svg`} alt="" /></span>
                </div>
              </div>

              <div className="icon_flex">
                <a onClick={() => navigate('/parent/search-result')}>
                  <figure>
                    <img src="/static/images/home.svg" alt="" />
                    <figcaption>Home</figcaption>
                  </figure>
                </a>

                <a onClick={() => navigate('/parent/code')}>
                  <figure>
                    <img src={`/static/images/profile-2user.svg`} alt="" />
                    <figcaption>Pairing</figcaption>
                  </figure>
                </a>

                <a onClick={() => navigate('/parent/videos')}>
                  <figure>
                    <img src="/static/images/videos.svg" alt="" />
                    <figcaption>Videos</figcaption>
                  </figure>
                </a>
                <a onClick={() => navigate('/parent/chat')}>
                  <figure>
                    <img src="/static/images/inbox_icon.svg" alt="" />
                    <figcaption>Inbox</figcaption>
                  </figure>
                </a>
                <a onClick={() => navigate('/parent/RecommendedClasses')}>
                  <figure>
                    <img src="/static/images/classes.svg" alt="" />
                    <figcaption>Classes</figcaption>
                  </figure>
                </a>
                <a onClick={() => setOpenCurr(true)}>

                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <img alt="flag" src={crData?.flag} width={25} />
                    {crData?.currency || 'USD'}
                  </div>


                </a>
                <a>
                  <ClickAwayListener onClickAway={handleClose3}>
                    <figure className="profile" onClick={handleClick3}>
                      <img src={userDetails?.image || "/static/images/amelia.png"} alt="" />
                      <figcaption>{userDetails?.name || ""} <span>
                        <img src={`/static/images/drop_icon.svg`} alt="" />
                      </span> </figcaption>
                      <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                      >
                        <MenuItem onClick={() => setOpenLog(true)}>Logout</MenuItem>
                      </Menu>
                    </figure>
                  </ClickAwayListener>
                </a>
                <div className="nv_lst_icns">
                  {token ? (
                    <IconButton
                      className="icon_btn"
                      onClick={() =>
                        zoom
                          ? window.open("/parent/wishlist")
                          : navigate("/parent/wishlist")
                      }
                    >
                      <figure>
                        <img
                          src={`/static/images/wishlist_icon.svg`}
                          alt="img"
                        />
                      </figure>
                    </IconButton>) : null}
                  {token ? (
                    <IconButton
                      className="icon_btn"
                      id="notification-button"
                      aria-controls={notificationAnchorEl ? "notification-menu" : undefined}
                      aria-expanded={notificationAnchorEl ? "true" : undefined}
                      aria-haspopup="true"
                      onClick={handleNotificationClick}
                    >
                      <figure>
                        <img src={`/static/images/bell_icon.svg`} alt="img" />
                      </figure>
                    </IconButton>

                  ) : null}
                  <Menu
                    className="noti_box"
                    id="notification-menu"
                    anchorEl={notificationAnchorEl}
                    open={Boolean(notificationAnchorEl)}
                    onClose={handleNotificationClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                  >
                    <div className="head">
                      <div className="lt_s">
                        <h2>Notifications</h2>
                      </div>

                    </div>
                    <ul className="body">
                      {notifications?.newNotification?.length ? (
                        <h6>Recent notifications</h6>
                      ) : (
                        ""
                      )}

                      {notifications?.newNotification?.length
                        ? notifications?.newNotification?.map((item: any) => {
                          return (
                            <>
                              <li
                                onClick={() =>
                                  zoom
                                    ? window.open("/parent/my-bookings")
                                    : navigate("/parent/my-bookings")
                                }
                                style={{
                                  backgroundColor: "lightgray",
                                  padding: "8px",
                                  borderRadius: "15px",
                                }}
                              >
                                <p>
                                  <strong>{item?.title}</strong> {item?.message}
                                </p>
                              </li>
                            </>
                          );
                        })
                        : ""}

                      {notifications?.oldNotification?.length ? (
                        <b>Older notifications</b>
                      ) : (
                        ""
                      )}
                      {notifications?.oldNotification?.length
                        ? notifications?.oldNotification?.map((item: any) => {
                          return (
                            <>
                              <li
                                onClick={() =>
                                  zoom
                                    ? window.open("/parent/my-bookings")
                                    : navigate("/parent/my-bookings")
                                }
                                style={{ padding: "8px", borderRadius: "15px" }}
                              >
                                <p>
                                  <strong>{item?.title}</strong> {item?.message}
                                </p>
                              </li>
                            </>
                          );
                        })
                        : ""}


                    </ul>
                  </Menu>

                </div>
              </div>


            </nav>
          </div>
        </div >
      </header >
      <LogoutModal
        open={openLog}
        setOpen={setOpenLog}
        onClose={handleCloseLog}
      />
      <CurrencyModal
        open={openCurr}
        setOpen={setOpenCurr}
        onClose={() => setOpenCurr(false)}
      />


    </>
  );
};

export default ParentHeader;
